import {
    GET_ALL_CART_PRODUCTS,
    RESPONSE_STATUS,
    RESPONSE_STATUS2,
    CLEAR_RESPONSE,
} from './cartTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case RESPONSE_STATUS2:
            return {
                ...state,
                invoice_ids: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_ALL_CART_PRODUCTS:
            return {
                ...state,
                buyer_cartitems: action.payload,
            }
        default:
            return state
    }
}
